import React, { useEffect } from 'react';
import '../styles/Pages.css';
import images from '../assets/index';

const industries = [
    {
        title: 'Banking & Financial Services',
        description: 'We help financial institutions drive smarter decisions with advanced analytics, AI-powered fraud detection, secure cloud transformation, and next-gen digital platforms that enhance customer trust and operational agility.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="8" y="30" width="64" height="42" rx="2" />
                <rect x="20" y="38" width="10" height="10" rx="1" /><rect x="35" y="38" width="10" height="10" rx="1" /><rect x="50" y="38" width="10" height="10" rx="1" />
                <rect x="20" y="54" width="10" height="10" rx="1" /><rect x="35" y="54" width="10" height="10" rx="1" /><rect x="50" y="54" width="10" height="10" rx="1" />
                <polyline points="16,30 40,10 64,30" />
                <circle cx="6" cy="22" r="4" /><circle cx="74" cy="22" r="4" />
                <line x1="6" y1="22" x2="18" y2="30" /><line x1="74" y1="22" x2="62" y2="30" />
                <line x1="2" y1="18" x2="6" y2="22" /><line x1="78" y1="18" x2="74" y2="22" />
                <line x1="2" y1="26" x2="6" y2="22" /><line x1="78" y1="26" x2="74" y2="22" />
            </svg>
        )
    },
    {
        title: 'Oil & Gas',
        description: 'From predictive maintenance to secure industrial IoT integration, we enable energy leaders to streamline operations, monitor field performance, and ensure cyber resilience across critical infrastructure.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="28" y="48" width="24" height="24" rx="1" />
                <polygon points="40,8 20,30 26,30 26,48 54,48 54,30 60,30" />
                <line x1="12" y1="72" x2="68" y2="72" />
                <line x1="36" y1="60" x2="44" y2="60" />
                <circle cx="60" cy="20" r="6" />
                <line x1="60" y1="10" x2="60" y2="6" /><line x1="66" y1="14" x2="70" y2="12" />
                <line x1="66" y1="20" x2="70" y2="20" /><line x1="54" y1="14" x2="50" y2="12" />
                <line x1="54" y1="20" x2="50" y2="20" /><line x1="60" y1="26" x2="60" y2="30" />
            </svg>
        )
    },
    {
        title: 'Telecommunications',
        description: 'Datamatics empowers telecom providers to modernize networks, personalize customer journeys, and unlock new revenue streams through intelligent automation and scalable cloud-native architectures.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="40" y1="48" x2="40" y2="72" /><line x1="20" y1="72" x2="60" y2="72" />
                <circle cx="40" cy="38" r="10" />
                <line x1="40" y1="28" x2="40" y2="6" />
                <path d="M 24 22 Q 10 18 6 10" /><path d="M 56 22 Q 70 18 74 10" />
                <path d="M 20 36 Q 6 32 4 24" /><path d="M 60 36 Q 74 32 76 24" />
                <path d="M 18 50 Q 4 52 4 62" /><path d="M 62 50 Q 76 52 76 62" />
                <circle cx="40" cy="38" r="4" />
            </svg>
        )
    },
    {
        title: 'Retail',
        description: 'Transform the customer experience with real-time analytics, supply chain intelligence, personalized marketing, and secure omnichannel platforms that anticipate and respond to consumer behavior.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="10" y="32" width="36" height="40" rx="1" />
                <rect x="18" y="40" width="8" height="8" rx="1" /><rect x="30" y="40" width="8" height="8" rx="1" />
                <rect x="18" y="54" width="8" height="8" rx="1" /><rect x="30" y="54" width="8" height="8" rx="1" />
                <polyline points="10,32 28,18 46,32" />
                <rect x="52" y="44" width="18" height="28" rx="1" />
                <polyline points="52,44 61,36 70,44" />
                <rect x="56" y="52" width="6" height="6" rx="1" /><rect x="56" y="62" width="6" height="6" rx="1" />
                <line x1="34" y1="72" x2="34" y2="64" /><line x1="26" y1="72" x2="26" y2="66" />
            </svg>
        )
    },
    {
        title: 'Manufacturing',
        description: 'We drive smart manufacturing with AI-driven production insights, IoT integration, quality control automation, and digital twins — all while maintaining cybersecurity across OT/IT ecosystems.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="8" y="44" width="64" height="28" rx="1" />
                <rect x="16" y="52" width="10" height="12" rx="1" /><rect x="35" y="52" width="10" height="12" rx="1" /><rect x="54" y="52" width="10" height="12" rx="1" />
                <circle cx="40" cy="32" r="12" />
                <line x1="28" y1="40" x2="18" y2="50" /><line x1="52" y1="40" x2="62" y2="50" />
                <circle cx="40" cy="32" r="4" />
                <line x1="40" y1="20" x2="40" y2="8" />
                <line x1="34" y1="10" x2="46" y2="10" />
            </svg>
        )
    },
    {
        title: 'Public Sector',
        description: 'Enabling governments and public service bodies with citizen-centric digital transformation, secure data platforms, and analytics to drive transparency, efficiency, and impact at scale.',
        icon: (
            <svg viewBox="0 0 80 80" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="40" cy="22" r="10" />
                <path d="M 20 72 Q 20 48 40 48 Q 60 48 60 72" />
                <circle cx="14" cy="30" r="7" />
                <path d="M 2 72 Q 2 54 14 54 Q 22 54 24 60" />
                <circle cx="66" cy="30" r="7" />
                <path d="M 78 72 Q 78 54 66 54 Q 58 54 56 60" />
                <line x1="6" y1="72" x2="74" y2="72" />
            </svg>
        )
    }
];
function IndustriesPage() {
    useEffect(() => {
        document.title = "Industries | Datamatics Consulting";
    }, []);
    return (
        <>
            <section className="hero-static industries-hero industries-hero-industry">
                <div className="hero-slide-wrapper">
                    <img src={images.industry3} alt="Diverse industries" className="hero-background-image" />
                    <div className="hero-overlay">
                        <div className="hero-content">
                            <h1 className="hero-title-industry">DIVERSE INDUSTRIES, DIVERSE SOLUTIONS.</h1>
                            <p className="hero-subtitle">Empowering businesses with end-to-end big data, analytics, and protection solutions to unlock ideas and accelerate impact.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="service-hero-section-service">
                <div className="container">
                    <div className="service-header-service">
                        <div className="service-label-row">
                            <span className="service-label-line"></span>
                            <p className="service-label-text">Industries</p>
                        </div>
                        <p className="service-description-service">
                            In a connected world where every industry is being redefined by data, Datamatics Consulting empowers businesses to lead with intelligence, speed, and resilience. We bring deep domain expertise and cutting-edge solutions across a wide range of sectors helping organizations not just keep up, but stay ahead in the digital age.
                        </p>
                    </div>
                    <h2 className="industries-main-heading">Powering Progress Across Industries</h2>
                </div>
                <div className="industries-grid container-industry">
                    {industries.map((industry, index) => (
                        <div key={index} className="industry-card">
                            <div className="industry-icon">{industry.icon}</div>
                            <div>
                                <h3>{industry.title}</h3>
                                <p>{industry.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <div className="subservice-page-sub">
                <section className="industries-bottom-banner">
                    <img src={images.industry2} alt="Industries driven by data" />
                    <div className="industries-banner-overlay">
                        <h2>Industries driven by data are the real winners</h2>
                    </div>
                </section>
            </div>
        </>
    );
}

export default IndustriesPage;